export default __webpack_public_path__ + "static/media/artist.71b29f0c.svg";